import { ConstraintFacilityInitialBuildBase } from './base/constraint-facility-initial-build-base';

export class ConstraintFacilityInitialBuild extends ConstraintFacilityInitialBuildBase { }